// Persona Carousel
import Flickity from 'flickity';
import FlickityFade from 'flickity-fade';

(function() {
    let availableCarousels = document.querySelectorAll('[data-module="persona-carousel"]');
    let initialIndex = 0;
    let firstClick = null;
    let firstClickFired = false;

    /* Handle Deeplinking and scrolling down to carousel */

    // Get the persona start-at ID which we'll use to active the current persona
    let deepLinkAttr = document.querySelectorAll('[data-start-at]');

    // If a deep link start-at persona is present. Find that button in the carousel navigation.
    if(deepLinkAttr.length){
        let startAtValue = deepLinkAttr[0].dataset.startAt;
        let startAtBtn = document.querySelectorAll('button[data-section="'+startAtValue+'"]');

        if(startAtBtn.length){
            firstClick = startAtBtn[0];
        }
    }

    function updateArrowTrackerWidth() {
        const carouselContainer = document.querySelector("#carousel-container");
        const arrowTracker = document.querySelector("#arrow-tracker");

        if (carouselContainer && arrowTracker) {
            // Calculate the total width of the children
            const children = Array.from(carouselContainer.children);
            const totalWidth = children.reduce((width, child) => {
                return width + child.offsetWidth;
            }, 0);

            // Update the max-width of #arrow-tracker
            arrowTracker.style.maxWidth = `${totalWidth}px`;
        }
    }

    // Initial calculation
    updateArrowTrackerWidth();

    // Add a resize event listener to update on size changes
    window.addEventListener("resize", () => {
        updateArrowTrackerWidth();
    });


    let navCarousel = null;
    let activeCarousel1 = null;
    let activeCarousel2 = null;
    let activeCarousel3 = [];

    let breakpoint = 1024;


    // Sub Sections with Dropdown Menu
    const isLandingPage = document.querySelectorAll('.is-landing-page');

    // Landing Page Carousel Options
    const landingPageCarouselOptions = {
        cellAlign: 'left',
        contain: true,
        lazyLoad: true,
        fade: true,
        draggable: false,
        initialIndex: initialIndex,
        adaptiveHeight: true,
        prevNextButtons: false,
        pageDots: false,
        dragThreshold: 100,
        on:{
            ready: function(){
                this.reloadCells();
            },
            change: function( i ) {
            },
            settle: function( idx ){

            }
        }
    };

    // Top Carousel Options
    const topCarouselOptions = {
        cellAlign: 'center',
        contain: false,
        wrapAround: true,
        lazyLoad: true,
        imagesLoaded: true,
        initialIndex: initialIndex,
        prevNextButtons: false,
        pageDots: false,
        on:{
            ready: function(){
                this.reloadCells();
                this.reposition();
            },
            change: function( index ) {
                console.log(index, activeCarousel2);

                if(activeCarousel2){
                    activeCarousel2.select( index );
                }
            }
        }
    };

    // Bottom Carousel Options
    const bottomCarouselOptions = {
        cellAlign: 'left',
        contain: true,
        lazyLoad: true,
        fade: true,
        initialIndex: initialIndex,
        adaptiveHeight: true,
        prevNextButtons: false,
        pageDots: false,
        dragThreshold: 100,
        on:{
            ready: function(){
                this.reloadCells();

                if(firstClick){
                    console.log('[DEEP LINK CAROUSEL]: Click the nav button');
                    window.setTimeout(function(){
                        firstClick.click();
                    }, 250);
                }
            },
            change: function( i ) {
                let personaBtn = document.querySelectorAll('.persona-btn');
                if(personaBtn){
                    personaBtn[i].click();
                }
            },
            settle: function( idx ){
                const cellElements =  this.getCellElements();
                const selectedEle = this.selectedElement;

                addSlideTabIndex( cellElements );
                removeSlideTabIndex( selectedEle );

                if((firstClick && deepLinkAttr) && !firstClickFired){

                    window.setTimeout(function(){
                        // console.log('[DEEP LINK CAROUSEL]: Slide as settled in, delay, now scroll down.');
                        deepLinkAttr[0].parentNode.parentNode.scrollIntoView(
                            {
                                behavior: "smooth",
                                block: "start",
                                inline: "nearest"
                            }
                        );
                    }, 1000);
                }

                firstClickFired = true;

                // console.log('[DEEP LINK CAROUSEL]: Settle Fired. \n Index:', idx, '\n cellElements:', cellElements, '\n selectedEle:', selectedEle);

                // Set Carousel DOM element and Flickity Options.
                const landingPageCarousels = selectedEle.querySelectorAll('.landing-page-subcarousel');
                console.log('landingPageCarousels: ', idx, selectedEle);

                landingPageCarousels.forEach(carousel => {
                    if (carousel.children.length > 1) {
                        // Set Dropdown Cariables
                        const dropdownButton = selectedEle.querySelectorAll('.dropdown-button');
                        const dropdownMenu = selectedEle.querySelectorAll('.dropdown-menu');

                        let isExpanded = false;

                        const c1 = new Flickity(carousel, landingPageCarouselOptions);
                        activeCarousel3.push(c1);

                        console.log('activeCarousel3', activeCarousel3.length, activeCarousel3);
;
                        for(var i = 0, length1 = activeCarousel3.length; i < length1; i++){
                            if(activeCarousel3[i].slides.length > 1){
                                const flickityInstance = activeCarousel3[i];
                                const flickityRoot = flickityInstance.element;
                                const parentNode = flickityRoot.parentNode;

                                const menuItems = parentNode.querySelectorAll('.goToSubCarouselSlide');

                                menuItems.forEach(item => {
                                    // Add a click event listener to each menu item
                                    item.addEventListener('click', function () {
                                        const slideIndex = parseInt(this.parentNode.dataset.index, 10);
                                        flickityInstance.select( slideIndex );
                                    });
                                });
                            }
                        }
                    }
                });
            }
        }
    };

    function addSlideTabIndex( arr ){
        if (arr) {
            for (var i = arr.length - 1; i >= 0; i--) {
                let tabbableLinks = arr[i].querySelectorAll('.tabbablelink-with-slide');

                if (tabbableLinks) {
                    for (var j = tabbableLinks.length - 1; j >= 0; j--) {
                        if( !tabbableLinks[j].hasAttribute('tabindex') ){
                            tabbableLinks[j].setAttribute('tabindex', '-1')
                            tabbableLinks[j].setAttribute('disabled', 'disabled');
                        }
                    }
                }
           };
       }
    }

    function removeSlideTabIndex( ele ){
        let tabbableLinks = ele.querySelectorAll('.tabbablelink-with-slide');

        if (tabbableLinks) {
            for (var i = tabbableLinks.length - 1; i >= 0; i--) {
                if( tabbableLinks[i].hasAttribute('tabindex') ){
                    tabbableLinks[i].removeAttribute('tabindex');
                    tabbableLinks[i].removeAttribute('disabled');
                }
            }
        }
    }

    for (var i = availableCarousels.length - 1; i >= 0; i--) {
        let wrapper = availableCarousels[i];
        let carouselThumbs = (wrapper.children.length) ? wrapper.children[0].children[0] : null;
        let carouselBottom = (wrapper.children.length) ? wrapper.children[1] : null;

        if (carouselThumbs && carouselBottom) {

            // Set Top Carousel for mobile on load if viewing on a small screen.
            if(window.innerWidth < breakpoint){
                activeCarousel1 = new Flickity(carouselThumbs, topCarouselOptions);
            }

            addEventListener("resize", (event) => {
                if(window.innerWidth < breakpoint){
                    topCarouselOptions.initialIndex = initialIndex;
                    activeCarousel1 = new Flickity(carouselThumbs, topCarouselOptions);
                }
                else{
                    if(activeCarousel1){
                        activeCarousel1.destroy();
                    }
                }
            });

            activeCarousel2 = new Flickity(carouselBottom, bottomCarouselOptions);

            let personaBtn = document.querySelectorAll('.persona-btn');

            for (var i = personaBtn.length - 1; i >= 0; i--) {
                personaBtn[i].addEventListener('click', function(){
                    let slidePercentage = '0px';
                    let arrow = document.getElementsByClassName('arrow');

                    if (this.dataset.slide > 0) {
                        slidePercentage = (100 * this.dataset.slide)+'%';
                    };

                    if(arrow.length && slidePercentage){
                        arrow[0].style.setProperty('--tw-translate-x', slidePercentage);
                    }

                    personaBtn.forEach( (ele) => {
                        ele.classList.remove('is-selected')
                    });

                    this.classList.add('is-selected');

                    initialIndex = this.dataset.slide;

                    if(window.innerWidth >= breakpoint){
                        activeCarousel2.select( initialIndex );
                    }
                    else{
                        activeCarousel1.select( initialIndex );
                        activeCarousel2.select( initialIndex );
                    }
                });
            };
        };
    };


})();